<template>
    <div
        :data-component="$options.name"
        class="ms-detail-gallery"
    >
        <div
            v-if="hasImages"
            class="h-full cursor-pointer"
            :class="{ 'flex flex-row': showImageGrid }"
            data-jest="button"
        >
            <img
                class="object-cover w-full h-full rounded-10"
                :class="{ 'ms-detail-gallery__gridLargeImage': showImageGrid }"
                :src="images?.grid[0].url"
                :alt="images?.grid[0].caption"
                data-index="0"
                @click="openGallery(0)"
            />
            <div
                v-if="showImageGrid"
                class="ml-24"
                data-print-imageGrid
            >
                <img
                    class="ms-detail-gallery__gridSmallImages mb-24"
                    :src="images?.grid[1].url"
                    :alt="images?.grid[1].caption"
                    data-index="1"
                    @click="openGallery(1)"
                />
                <img
                    class="ms-detail-gallery__gridSmallImages"
                    :src="images?.grid[2].url"
                    :alt="images?.grid[2].caption"
                    data-index="2"
                    @click="openGallery(2)"
                />
            </div>
            <div class="absolute flex flex-row bottom-16 left-16">
                <cs-secondary-button
                    :isSmall="true"
                    :hasWhiteBackground="true"
                    :isCentered="true"
                    @click="openGallery(0)"
                >
                    <template #icon><ms-image /></template>
                    <template #default>{{ badgeText }}</template>
                </cs-secondary-button>
                <div
                    v-if="threeSixtyViewUrl"
                    class="ml-10"
                    @click="openThreeSixtyLightbox(exposeeId)"
                >
                    <cs-secondary-button
                        :isSmall="true"
                        :hasWhiteBackground="true"
                        :isCentered="true"
                    >
                        <template #icon><ms-three-sixty-degree /></template>
                        <template #default>360° Ansicht</template>
                    </cs-secondary-button>
                </div>
            </div>
        </div>
        <div
            v-else
            class="flex flex-col items-center justify-center h-full bg-color-brand-beige-50 rounded-10"
        >
            <ms-fall-back />
            <ms-headline
                type="h3"
                class="mt-8"
                :isSpan="true"
                >Es ist leider kein Bild vorhanden</ms-headline
            >
            <div class="absolute flex flex-row bottom-16 left-16">
                <div @click="openThreeSixtyLightbox(exposeeId)">
                    <cs-secondary-button
                        v-if="threeSixtyViewUrl"
                        :isSmall="true"
                        :hasWhiteBackground="true"
                        :isCentered="true"
                    >
                        <template #icon><ms-three-sixty-degree /></template>
                        <template #default>360° Ansicht</template>
                    </cs-secondary-button>
                </div>
            </div>
        </div>
        <ms-detail-three-sixty-lightbox
            v-if="threeSixtyViewUrl"
            :isVisible="threeSixtyLightboxIsVisible"
            :iFrameUrl="threeSixtyViewUrl"
            @closeLightbox="closeThreeSixtyLightbox"
        />
        <cs-gallery
            v-if="images"
            v-model:isVisible="galleryVisible"
            class="z-overlay-canvas"
            :images="images?.gallery"
            :startIndex="galleryIndex"
            :ads="galleryAds"
            :trackingParameter="galleryTracking"
        />
    </div>
</template>
<script lang="ts" src="./MsDetailGallery.ts" />
<style scoped lang="scss" src="./MsDetailGallery.scss" />
